import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["commentForm", "textarea", "submitBtn"];

  toggle() {
    this.commentFormTarget.classList.toggle("hidden");
    if (!this.commentFormTarget.classList.contains("hidden")) {
      this.textareaTarget.focus();
      this.resize();
    }
  }

  resize() {
    this.#resizePreservingScroll();
    this.updateSubmit();
  }

  #resizePreservingScroll() {
    const textarea = this.textareaTarget;
    const verticalOffset = 30;
    const scrollContainer = textarea.closest(".overflow-y-auto");
    const prevHeight = textarea.offsetHeight;
    const savedScroll = scrollContainer?.scrollTop;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight + verticalOffset}px`;
    if (scrollContainer) {
      scrollContainer.scrollTop = savedScroll + (textarea.offsetHeight - prevHeight);
    }
  }

  updateSubmit() {
    this.submitBtnTarget.disabled = this.textareaTarget.value.trim().length === 0;
  }
}
